import { DocumentNode, gql } from '@apollo/client';
import { HStack, StackProps } from '@chakra-ui/react';
import * as React from 'react';

import { Header_EventAlertFragment } from './graphql-types/Header_EventAlertFragment';

import { DropdownMenu } from '../../DropdownMenu';
import { EventAlertDetail } from './EventAlertDetail';

export const Header: React.FC<
  { eventAlert: Header_EventAlertFragment } & StackProps
> & {
  eventAlertFragment: DocumentNode;
} = (props) => {
  const { eventAlert, ...stackProps } = props;
  return (
    <HStack
      justifyContent="space-between"
      spacing="2"
      alignItems="center"
      {...stackProps}
    >
      <EventAlertDetail eventAlert={eventAlert} />
      <DropdownMenu
        post={eventAlert}
        aria-label="more options"
        alignSelf="start"
      />
    </HStack>
  );
};

Header.eventAlertFragment = gql`
  fragment Header_EventAlertFragment on EventAlert {
    ...DropdownMenu_PostFragment
    ...EventAlertDetail_EventAlertFragment
  }
  ${DropdownMenu.postFragment}
  ${EventAlertDetail.eventAlertFragment}
`;
